// import { IResultsAnalytics } from "./IResultsAnalytics";

export type ActivityLogItem = {
    date: string;
    time: string;
    description: string;
    timestamp: number
};

export enum TimeSpan {
    MONTH, YEAR, ALL
}

export interface IUsersAnalytics {
    getUsersCount(): number;
    getUserCountPerMonth(): Map<string, number>;
    getAvgNewUserPerMonth(): number;
    getAvgNewUserPerYear(): number;
    getAvgDailyActiveUsers(): number;
    getAvgMonthlyActiveUsers(): number;
    getAvgYearlyActiveUsers(): number;
    getSubmittedResultsCount(): number;
    getSubmittedResultsCountPerMonth(): Map<string, number>;
    getActivityLog(): ActivityLogItem[];
    // getAnalyticsForTimeSpan(span: TimeSpan, value?: number): IResultsAnalytics;
}


// WEBPACK FOOTER //
// ./src/utility/admin/UsersControls/UsersAnalytics/IUsersAnalytics.ts